// extracted by mini-css-extract-plugin
export default {"container":"MrBH","containerFetching":"GXFz"};